import { apiRequest } from "./api";

// Maps a backend PriorYearResponse onto the wizard's shape.
function fromPriorYearResponse(data) {
  return {
    line8aChecked: !!data.line8aChecked,
    line8bVins: data.line8bVins || [],
    line9Checked: !!data.line9Checked,
    line9Transfers: (data.line9Transfers || []).map((t) => ({
      id: t.id,
      vin: t.vin,
      buyerName: t.buyerName,
      transferDate: t.transferDate,
    })),
  };
}

// GET /returns/{returnId}/prior-year -> saved Part II lines 8a/8b/9 data, or
// empty defaults if nothing's been saved yet.
export async function getPriorYear(returnId) {
  const data = await apiRequest(`/returns/${returnId}/prior-year`);
  return fromPriorYearResponse(data);
}

// PUT /returns/{returnId}/prior-year -> full-replace save of lines 8a/8b/9.
// 409 if the return is no longer a draft, 422 on VIN/line-9 field validation
// failures (invalid VIN, missing buyer name/date).
export async function savePriorYear(returnId, { line8aChecked, line8bVins, line9Checked, line9Transfers }) {
  const data = await apiRequest(`/returns/${returnId}/prior-year`, {
    method: "PUT",
    body: {
      line8aChecked: !!line8aChecked,
      line8bVins: line8bVins || [],
      line9Checked: !!line9Checked,
      line9Transfers: (line9Transfers || []).map((t) => ({
        vin: t.vin,
        buyerName: t.buyerName,
        transferDate: t.transferDate,
      })),
    },
  });
  return fromPriorYearResponse(data);
}
